export default function CommasToBullets(list) {

    const items = list.split('//').map(x => x.trim());

    return (
        <ul>
            {items.map((item, index) =>
                <li key={index}>{item}</li>
            )}

        </ul>
    );
}